export const OrderIcon = ({order}) => {
    return (
        <svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
            transform: order === 'desc' ? "scale(1,-1)" : "none"
        }}>
            <path d="M6.25 8.25H15.25V9.75H6.25M6.25 13.5V12H19.75V13.5M6.25 4.5H10.75V6H6.25V4.5Z" fill="black" fillOpacity="0.56"/>
        </svg>
    )
}
